import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-wishlist-info-dialog',
  imports: [MatDialogModule],
  templateUrl: './wishlist-info-dialog.component.html',
  styleUrl: './wishlist-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistInfoDialogComponent implements OnInit, OnDestroy {
  dialogRef = inject(MatDialogRef<WishlistInfoDialogComponent>);
  message = inject(MAT_DIALOG_DATA).message;

  private dialogTimeout: number = 0;
  private readonly dialogTimeoutDelay = 5000;

  ngOnInit(): void {
    this.dialogTimeout = setTimeout(() => {
      this.dialogRef.close();
    }, this.dialogTimeoutDelay);
  }

  ngOnDestroy(): void {
    clearTimeout(this.dialogTimeout);
  }
}
